import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useApi } from "../lib/api";
import { PageTitle } from "../components/kit";

export function PaymentSuccess() {
  const api = useApi();
  const [params] = useSearchParams();
  const sid = params.get("session_id") || "";
  const [state, setState] = useState("checking");
  useEffect(() => {
    let tries = 0;
    let stop = false;
    const tick = async () => {
      if (stop) return;
      try {
        const r = await api("get", `/payments/status/${encodeURIComponent(sid)}`);
        if (r.payment_status === "paid") { setState("paid"); return; }
        if (["expired", "failed"].includes(r.payment_status)) { setState(r.payment_status); return; }
      } catch { setState("unknown"); return; }
      tries += 1;
      if (tries < 15) setTimeout(tick, 2000); else setState("pending");
    };
    if (sid) tick(); else setState("unknown");
    return () => { stop = true; };
  }, [api, sid]);
  const msg: Record<string, string> = {
    checking: "Confirming your payment with Stripe…",
    paid: "Payment confirmed. Your plan or sponsored placement is now active.",
    pending: "Payment is still processing. Check Billing again in a minute.",
    expired: "This checkout expired. No charge was made.",
    failed: "The payment failed. No charge was made.",
    unknown: "We couldn't find this payment.",
  };
  return (
    <div className="mx-auto max-w-xl px-4 py-16" data-testid="payment-success-page">
      <PageTitle kicker="Billing" title={state === "paid" ? "Thank you" : "Payment status"} />
      <p className="card text-sm" data-testid="payment-status-message">{msg[state]}</p>
      <Link to="/vendor" className="btn btn-primary mt-4" data-testid="payment-back-dashboard">Back to dashboard</Link>
    </div>
  );
}

export function PaymentCancel() {
  return (
    <div className="mx-auto max-w-xl px-4 py-16" data-testid="payment-cancel-page">
      <PageTitle kicker="Billing" title="Checkout cancelled" />
      <p className="card text-sm">No payment was taken. You can try again from the Billing tab.</p>
      <Link to="/vendor" className="btn btn-primary mt-4" data-testid="payment-cancel-back">Back to dashboard</Link>
    </div>
  );
}
